export default __webpack_public_path__ + "static/media/bg4.98857914.png";